module.exports = __webpack_public_path__ + "img/banner5555.png";